export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 1,
    "title": "Which AI technique allows systems to learn patterns from data instead of relying on fixed rules?",
    "description": "Machine learning"
  },
  {
    "id": 2,
    "topic_id": 1,
    "title": "Which machine learning approach is used to predict categorical values?",
    "description": "Supervised learning"
  },
  {
    "id": 3,
    "topic_id": 1,
    "title": "Which learning method identifies hidden patterns without labeled data?",
    "description": "Unsupervised learning"
  },
  {
    "id": 4,
    "topic_id": 1,
    "title": "Which learning approach trains an agent using rewards and penalties?",
    "description": "Reinforcement learning"
  },
  {
    "id": 5,
    "topic_id": 1,
    "title": "Which deep learning architecture uses self-attention to understand relationships in sequences?",
    "description": "Transformer"
  },
  {
    "id": 6,
    "topic_id": 1,
    "title": "Which type of model uses many layers of neural networks to learn complex patterns from raw data?",
    "description": "Deep learning model"
  },
  {
    "id": 7,
    "topic_id": 1,
    "title": "Which type of language model is smaller, efficient, and commonly runs on local infrastructure?",
    "description": "Small language model (SLM)"
  },
  {
    "id": 8,
    "topic_id": 1,
    "title": "What AI technique is used to generate synthetic data such as fake logs or malware variants?",
    "description": "Generative AI"
  },
  {
    "id": 9,
    "topic_id": 2,
    "title": "Reducing numerical precision in a model’s weights to make it more efficient is known as what?",
    "description": "Quantization"
  },
  {
    "id": 10,
    "topic_id": 1,
    "title": "What term describes a model that performs well on training data but poorly on new data?",
    "description": "Overfitting"
  },
  {
    "id": 11,
    "topic_id": 1,
    "title": "T/F: Statistical learning focuses on explanation and understanding of data relationships.",
    "description": "True; statistical learning emphasizes explanation and understanding, supporting ML by analyzing relationships between variables."
  },
  {
    "id": 12,
    "topic_id": 1,
    "title": "T/F: Zero-shot prompting requires at least one example in the prompt.",
    "description": "False; zero-shot prompting includes no examples; the model relies entirely on its pre-trained knowledge."
  },
  {
    "id": 13,
    "topic_id": 3,
    "title": "T/F: In cybersecurity contexts, concept drift can occur when attackers change their techniques over time.",
    "description": "True; as attacker behavior evolves or user behavior shifts, models trained on old data may perform poorly due to concept drift."
  },
  {
    "id": 14,
    "topic_id": 1,
    "title": "Which principle limits collection of user information to only what is necessary for an AI system?",
    "description": "Data minimization"
  },
  {
    "id": 15,
    "topic_id": 1,
    "title": "What type of data includes JSON, XML, or email headers?",
    "description": "Semi-structured data"
  },
  {
    "id": 16,
    "topic_id": 2,
    "title": "What process ensures data has not been altered by using checksums or hashes?",
    "description": "Data integrity"
  },
  {
    "id": 17,
    "topic_id": 1,
    "title": "What term describes the full history of how data moves and transforms through an AI pipeline?",
    "description": "Data lineage"
  },
  {
    "id": 18,
    "topic_id": 2,
    "title": "T/F: Data sanitization removes or masks personal identifiers that the model does not need.",
    "description": "True; data sanitization hides or removes sensitive information during preparation."
  },
  {
    "id": 19,
    "topic_id": 1,
    "title": "Which technique generates new samples to correct class imbalance in a training dataset?",
    "description": "Oversampling (or SMOTE, Synthetic Minority Oversampling Technique)"
  },
  {
    "id": 20,
    "topic_id": 2,
    "title": "What component in a RAG system stores embeddings for similarity search?",
    "description": "Vector store"
  },
  {
    "id": 21,
    "topic_id": 1,
    "title": "T/F: Adversarial training weakens a model by exposing it to misleading inputs.",
    "description": "False; adversarial training strengthens model robustness by training it to detect adversarial examples."
  },
  {
    "id": 22,
    "topic_id": 2,
    "title": "What deployment control ensures only authorized users or systems can access an AI model?",
    "description": "Authentication and authorization"
  },
  {
    "id": 23,
    "topic_id": 2,
    "title": "What monitoring activity detects changes in input patterns that degrade model accuracy?",
    "description": "Data drift detection"
  },
  {
    "id": 24,
    "topic_id": 2,
    "title": "What form of human involvement requires a person to approve AI decisions before action is taken?",
    "description": "Human-in-the-loop"
  },
  {
    "id": 25,
    "topic_id": 2,
    "title": "Which security practice protects a deployed AI model’s parameters from theft or tampering?",
    "description": "Model protection (e.g., encryption, watermarking)"
  },
  {
    "id": 26,
    "topic_id": 3,
    "title": "What attack occurs when an adversary writes prompts that override a model’s system instructions?",
    "description": "Prompt injection"
  },
  {
    "id": 27,
    "topic_id": 2,
    "title": "What type of poisoning attack inserts malicious or mislabeled data into a model’s training set?",
    "description": "Data poisoning"
  },
  {
    "id": 28,
    "topic_id": 2,
    "title": "What attack involves tricking developers into using a tampered pretrained model that already contains backdoors?",
    "description": "Model poisoning"
  },
  {
    "id": 29,
    "topic_id": 1,
    "title": "What technique attempts to extract sensitive information from a model’s training data by analyzing its outputs?",
    "description": "Model inversion"
  },
  {
    "id": 30,
    "topic_id": 3,
    "title": "What attack involves a user deliberately bypassing an AI model’s safety rules using layered or role-play prompts?",
    "description": "Jailbreaking"
  },
  {
    "id": 31,
    "topic_id": 3,
    "title": "Which attack modifies inputs (such as images or text) to cause misclassification or unintended model behavior?",
    "description": "Input manipulation"
  },
  {
    "id": 32,
    "topic_id": 3,
    "title": "Which attack gradually shifts a model’s behavior over time by influencing the data it consumes during operation?",
    "description": "Model skewing"
  },
  {
    "id": 33,
    "topic_id": 3,
    "title": "Which type of attack allows an adversary to determine whether a specific record was included in a model’s training set?",
    "description": "Membership inference"
  },
  {
    "id": 34,
    "topic_id": 4,
    "title": "What do we call the replication or extraction of an AI model through repeated queries or stolen model files?",
    "description": "Model theft"
  },
  {
    "id": 35,
    "topic_id": 3,
    "title": "T/F: Output integrity attacks target a model’s underlying architecture to change how it computes predictions.",
    "description": "False; they manipulate outputs after inference, not the model’s architecture."
  },
  {
    "id": 36,
    "topic_id": 4,
    "title": "T/F: Excessive agency happens when an AI system is given too much autonomy to perform actions without proper oversight.",
    "description": "True; excessive agency occurs when an AI system can take high-impact actions with insufficient human control."
  },
  {
    "id": 37,
    "topic_id": 2,
    "title": "Which control filters, rewrites, or blocks unsafe prompts before they reach a model?",
    "description": "Prompt firewall"
  },
  {
    "id": 38,
    "topic_id": 2,
    "title": "Which OWASP resource lists risks such as prompt injection, misinformation, and sensitive information disclosure for language models?",
    "description": "OWASP Top Ten for LLMs"
  },
  {
    "id": 39,
    "topic_id": 2,
    "title": "What model-level control uses structured, fixed prompt formats to prevent users from overriding system instructions?",
    "description": "Prompt templates"
  },
  {
    "id": 40,
    "topic_id": 2,
    "title": "What security control inspects, filters, and sanitizes both prompts and model outputs at the gateway layer?",
    "description": "Prompt firewall"
  },
  {
    "id": 41,
    "topic_id": 2,
    "title": "What measure restricts how many requests or tokens a user can consume within a given time window?",
    "description": "Rate limiting or token-based quotas"
  },
  {
    "id": 42,
    "topic_id": 2,
    "title": "What security control limits an AI system to only the necessary input types, such as text-only?",
    "description": "Modality limits"
  },
  {
    "id": 43,
    "topic_id": 2,
    "title": "What network security measure restricts AI endpoints to specific IP addresses, private subnets, or VPNs?",
    "description": "Network isolation"
  },
  {
    "id": 44,
    "topic_id": 2,
    "title": "T/F: Jailbreak testing evaluates whether a model can be manipulated into bypassing its guardrails.",
    "description": "True; jailbreak tests deliberately probe whether guardrails can be bypassed through crafted prompts."
  },
  {
    "id": 45,
    "topic_id": 2,
    "title": "What form of encryption protects data processed inside secure hardware-based enclaves?",
    "description": "Encryption in use (confidential computing)"
  },
  {
    "id": 46,
    "topic_id": 2,
    "title": "What data protection method permanently removes sensitive details from input or output content?",
    "description": "Data redaction"
  },
  {
    "id": 47,
    "topic_id": 2,
    "title": "T/F: Data masking permanently deletes sensitive information from a dataset.",
    "description": "False; data masking replaces sensitive values with realistic but fictitious substitutes rather than deleting them."
  },
  {
    "id": 48,
    "topic_id": 2,
    "title": "What access control method assigns permissions based on user roles such as analyst or administrator?",
    "description": "Role-based access control (RBAC)"
  },
  {
    "id": 49,
    "topic_id": 1,
    "title": "What principle requires collecting and storing only the minimum data necessary for an AI task?",
    "description": "Data minimization"
  },
  {
    "id": 50,
    "topic_id": 2,
    "title": "What logging-based practice helps detect abnormal activity, validate guardrails, and identify prompt injection attempts?",
    "description": "Log monitoring"
  },
  {
    "id": 51,
    "topic_id": 2,
    "title": "What monitoring practice captures and reviews user inputs to detect malicious queries like prompt injection?",
    "description": "Prompt monitoring"
  },
  {
    "id": 52,
    "topic_id": 2,
    "title": "What monitoring practice reviews AI outputs to ensure they do not contain sensitive, offensive, or disallowed content?",
    "description": "Response monitoring"
  },
  {
    "id": 53,
    "topic_id": 2,
    "title": "What system aggregates and analyzes logs from AI prompts, outputs, infrastructure, and security events for anomaly detection?",
    "description": "SIEM (Security Information and Event Management)"
  },
  {
    "id": 54,
    "topic_id": 2,
    "title": "What practice removes or masks sensitive information such as PII from logs before storage?",
    "description": "Log sanitization"
  },
  {
    "id": 55,
    "topic_id": 2,
    "title": "What control protects logs from tampering using append-only storage or digital signatures?",
    "description": "Log integrity protection"
  },
  {
    "id": 56,
    "topic_id": 2,
    "title": "T/F: Monitoring model confidence levels helps determine when an AI system should escalate decisions to a human reviewer.",
    "description": "True; low-confidence outputs indicate uncertainty and may require human oversight."
  },
  {
    "id": 57,
    "topic_id": 2,
    "title": "What monitoring practice tracks how frequently requests are sent to an AI system to detect spikes indicating attacks or misuse?",
    "description": "Rate monitoring"
  },
  {
    "id": 58,
    "topic_id": 2,
    "title": "What cost metric must be tracked to identify workflows generating long, expensive outputs in generative AI systems?",
    "description": "Token usage (input and output tokens)"
  },
  {
    "id": 59,
    "topic_id": 2,
    "title": "What type of audit examines outputs for fabricated facts, unsupported claims, or invented citations?",
    "description": "Hallucination auditing"
  },
  {
    "id": 60,
    "topic_id": 2,
    "title": "What audit method compares outputs across demographic groups to detect fairness issues such as unequal error rates?",
    "description": "Bias and fairness auditing"
  },
  {
    "id": 61,
    "topic_id": 2,
    "title": "T/F: Accuracy auditing focuses on detecting completely false responses rather than partially correct or misinterpreted answers.",
    "description": "False; accuracy auditing checks for both fully and partially incorrect outputs."
  },
  {
    "id": 62,
    "topic_id": 2,
    "title": "What audit confirms that access control policies such as least privilege, authentication, and segregation of duties are functioning correctly?",
    "description": "Access and security compliance auditing"
  },
  {
    "id": 63,
    "topic_id": 2,
    "title": "What monitoring practice detects sudden cost spikes that may indicate misuse, coding errors, or compromised credentials?",
    "description": "Cost monitoring (AI FinOps)"
  },
  {
    "id": 64,
    "topic_id": 3,
    "title": "What type of AI-generated content creates hyper-realistic synthetic video or audio used to impersonate real people?",
    "description": "Deepfakes"
  },
  {
    "id": 65,
    "topic_id": 3,
    "title": "What attack technique uses AI to clone a person’s voice or likeness for financial fraud or authentication spoofing?",
    "description": "Impersonation"
  },
  {
    "id": 66,
    "topic_id": 3,
    "title": "What type of harmful content spread by AI is shared unintentionally by people who believe it is real?",
    "description": "Misinformation"
  },
  {
    "id": 67,
    "topic_id": 3,
    "title": "What term describes deliberately crafted false content enhanced by AI and distributed to manipulate opinions or outcomes?",
    "description": "Disinformation"
  },
  {
    "id": 68,
    "topic_id": 3,
    "title": "T/F: Attackers use AI-based honeypot fingerprinting to avoid interacting with decoy systems designed to lure them.",
    "description": "True; AI can analyze service responses and detect honeypot patterns to evade them."
  },
  {
    "id": 69,
    "topic_id": 3,
    "title": "What AI technique generates content specifically designed to evade filters or mislead decision-making systems, often using GANs?",
    "description": "Adversarial content"
  },
  {
    "id": 70,
    "topic_id": 3,
    "title": "What activity uses AI to accelerate reconnaissance by summarizing open source and leaked data to identify high-value targets?",
    "description": "Automated reconnaissance"
  },
  {
    "id": 71,
    "topic_id": 3,
    "title": "What generative AI capability allows attackers to rewrite malware code continuously so each copy looks unique?",
    "description": "Polymorphic malware generation"
  },
  {
    "id": 72,
    "topic_id": 3,
    "title": "T/F: Automated data correlation allows attackers to link stolen credentials, personal details, and system data into prioritized target lists.",
    "description": "True; AI aggregates and analyzes large datasets to highlight exploitable accounts."
  },
  {
    "id": 73,
    "topic_id": 3,
    "title": "What AI-driven capability automates the selection of exploits, creation of payloads, and execution of multistep attacks?",
    "description": "Automated attack generation"
  },
  {
    "id": 74,
    "topic_id": 3,
    "title": "What AI capability lets attackers detect and bypass honeypots by comparing service fingerprints and timing patterns to known decoy frameworks?",
    "description": "Honeypot detection"
  },
  {
    "id": 75,
    "topic_id": 3,
    "title": "What AI-enhanced attack dynamically adjusts packet types, ports, and timing during a traffic flood to evade mitigation?",
    "description": "AI-driven adaptive DDoS"
  },
  {
    "id": 76,
    "topic_id": 3,
    "title": "What type of AI-enabled tool assists developers inside an IDE by flagging insecure coding patterns and suggesting safer alternatives?",
    "description": "AI-powered IDE plug-ins"
  },
  {
    "id": 77,
    "topic_id": 3,
    "title": "What browser capability uses AI to automatically highlight indicators of compromise on web pages and show real-time risk scores?",
    "description": "AI-enhanced browser plug-ins (e.g., VirusTotal VT4Browsers)"
  },
  {
    "id": 78,
    "topic_id": 3,
    "title": "What CLI integration lets analysts summarize nmap or vulnerability scan results directly in the terminal?",
    "description": "AI-enabled CLI plug-ins"
  },
  {
    "id": 79,
    "topic_id": 3,
    "title": "What kind of AI tool allows analysts to query security data in natural language and receive structured results?",
    "description": "AI-driven chatbots"
  },
  {
    "id": 80,
    "topic_id": 3,
    "title": "What process does AI accelerate by identifying which vulnerabilities in a long scan report should be addressed first based on risk and context?",
    "description": "Vulnerability analysis and prioritization"
  },
  {
    "id": 81,
    "topic_id": 3,
    "title": "T/F: AI-enabled automated penetration testing can identify common attack vectors like SQL injection or XSS without human-crafted test cases.",
    "description": "True; AI tools can simulate common attacks and identify vulnerabilities automatically."
  },
  {
    "id": 82,
    "topic_id": 3,
    "title": "What AI capability detects unusual user or system behavior by comparing activity against established baselines?",
    "description": "Anomaly detection"
  },
  {
    "id": 83,
    "topic_id": 3,
    "title": "What AI function correlates scattered events, such as repeated small data extractions across servers, to reveal coordinated attacks?",
    "description": "Pattern recognition"
  },
  {
    "id": 84,
    "topic_id": 2,
    "title": "What process uses AI to evaluate system architecture diagrams and identify likely attack paths such as account takeover or injection?",
    "description": "Threat modeling"
  },
  {
    "id": 85,
    "topic_id": 3,
    "title": "What AI capability monitors accounts and transactions for unusual combinations of actions, such as new devices and large transfers?",
    "description": "Fraud detection"
  },
  {
    "id": 86,
    "topic_id": 3,
    "title": "T/F: AI-generated scripts in low-code and no-code platforms allow non-developers to build automation workflows more easily.",
    "description": "True; AI reduces the technical barrier for workflow creation."
  },
  {
    "id": 87,
    "topic_id": 1,
    "title": "What distinguishes an AI agent from a simple automation script in cybersecurity operations?",
    "description": "AI agents can plan, monitor, and adapt decisions autonomously within defined scope."
  },
  {
    "id": 88,
    "topic_id": 3,
    "title": "What AI feature in CI/CD pipelines automatically reverts deployments when metrics such as error rates or response times degrade?",
    "description": "Automatic rollback"
  },
  {
    "id": 89,
    "topic_id": 4,
    "title": "What organizational structure provides shared standards, platforms, and oversight for AI while allowing business units to build their own solutions?",
    "description": "Hub-and-spoke model"
  },
  {
    "id": 90,
    "topic_id": 4,
    "title": "What type of document establishes mandatory rules and intent for how AI must be used across an organization?",
    "description": "Policy"
  },
  {
    "id": 91,
    "topic_id": 4,
    "title": "Which AI role evaluates use cases, performs privacy and impact assessments, and tracks mitigations in a risk register?",
    "description": "AI risk analyst"
  },
  {
    "id": 92,
    "topic_id": 4,
    "title": "What responsible AI principle ensures that similar cases receive similar outcomes and that harmful subgroup disparities are monitored and mitigated?",
    "description": "Fairness"
  },
  {
    "id": 93,
    "topic_id": 4,
    "title": "T/F: Transparency requires teams to explain when AI is involved in a system and disclose its limitations in plain language.",
    "description": "True; transparency means users understand AI involvement, data use, and system limits."
  },
  {
    "id": 94,
    "topic_id": 4,
    "title": "What responsible AI principle ensures systems behave predictably and consistently across releases and over time?",
    "description": "Consistency"
  },
  {
    "id": 95,
    "topic_id": 4,
    "title": "Which risk category includes failures such as a model exposing confidential training data or leaking internal documents in responses?",
    "description": "Accidental data leakage"
  },
  {
    "id": 96,
    "topic_id": 4,
    "title": "Under the EU AI Act, which category includes AI systems used in employment screening, credit scoring, and healthcare diagnostics?",
    "description": "High-risk systems"
  },
  {
    "id": 97,
    "topic_id": 4,
    "title": "What internationally adopted framework defines four functions (Govern, Map, Measure, and Manage) to structure AI risk management?",
    "description": "NIST AI Risk Management Framework (AI RMF)"
  },
  {
    "id": 98,
    "topic_id": 4,
    "title": "T/F: Corporate AI policies should require all employees to use any AI tool they choose as long as it improves productivity.",
    "description": "False; policies must restrict use to sanctioned tools to prevent data exposure."
  },
  {
    "id": 99,
    "topic_id": 4,
    "title": "What intellectual-property risk arises when training data includes copyrighted material with unclear or prohibited licensing?",
    "description": "IP-related risk from improper data provenance or licensing"
  },
  {
    "id": 100,
    "topic_id": 4,
    "title": "What type of external review provides independent verification that an organization’s AI controls and documentation meet regulatory and customer expectations?",
    "description": "Third-party compliance evaluation"
  },
  {
    "id": 101,
    "topic_id": 200,
    "title": "Explain the differences between AI, machine learning, deep learning, and statistical learning.",
    "description": "AI is a broad field focused on creating systems that mimic human thinking. Machine learning is a part of AI that learns from data. Deep learning is a specialized form of machine learning that uses neural networks. Statistical learning provides the mathematical basis for analyzing data and identifying patterns."
  },
  {
    "id": 102,
    "topic_id": 200,
    "title": "List key uses of AI in cybersecurity.",
    "description": "AI is used to detect malware, identify phishing emails, analyze user behavior, and detect intrusions. Deep learning models can find patterns in raw network data or code. Transformers and language models can summarize logs or threat reports."
  },
  {
    "id": 103,
    "topic_id": 200,
    "title": "Compare LLMs and SLMs.",
    "description": "LLMs are powerful and flexible. They require large datasets and significant computing power. SLMs are smaller and more efficient. They are well suited for specific tasks and can run locally with fewer resources."
  },
  {
    "id": 104,
    "topic_id": 200,
    "title": "Understand how generative AI is used in cybersecurity.",
    "description": "Defensive uses include generating training data and simulating attacks. Offensive uses include creating deepfakes and writing polymorphic malware."
  },
  {
    "id": 105,
    "topic_id": 200,
    "title": "Match learning types to cybersecurity tasks.",
    "description": "Use supervised learning for tasks like phishing detection. Use unsupervised learning for anomaly detection when labeled data is not available. Use reinforcement learning to support adaptive security strategies in dynamic environments."
  },
  {
    "id": 106,
    "topic_id": 200,
    "title": "Recognize the importance of model validation and optimization.",
    "description": "Validation ensures a model works well on new data. Fine-tuning improves model accuracy on specific tasks. Pruning and quantization make models faster and more efficient for deployment."
  },
  {
    "id": 107,
    "topic_id": 200,
    "title": "Define prompt engineering and identify prompting strategies.",
    "description": "Prompt engineering helps shape how a generative model responds. Zero-shot prompting gives only the task. One-shot and multi-shot prompting include examples to guide the model."
  },
  {
    "id": 108,
    "topic_id": 200,
    "title": "Understand why data security is essential for AI systems.",
    "description": "AI systems depend on large volumes of data, often including sensitive or proprietary information. This data must be protected against breaches, tampering, and misuse to ensure models behave reliably and ethically."
  },
  {
    "id": 109,
    "topic_id": 200,
    "title": "Recognize the differences among data types used in AI.",
    "description": "Structured data is highly organized and easy to secure, like tables in a database. Semi-structured data, such as emails or log files, has some structure but needs custom validation. Unstructured data, including images, video, and plain text, is harder to manage and must be carefully scanned and encrypted."
  },
  {
    "id": 110,
    "topic_id": 200,
    "title": "Explain how to protect the integrity of data.",
    "description": "Maintaining data integrity involves confirming that data remains accurate and unchanged. Common practices include using cryptographic hashes, applying access controls, and tracking data versions. These steps help prevent manipulation and ensure trustworthy model training."
  },
  {
    "id": 111,
    "topic_id": 200,
    "title": "Describe how RAG systems work and their security risks.",
    "description": "RAG enhances generative AI by retrieving relevant external documents at runtime. This improves output quality but also creates new vulnerabilities. Vector stores must be protected, retrieved data must be verified, and privacy controls should ensure the model does not leak sensitive content."
  },
  {
    "id": 112,
    "topic_id": 200,
    "title": "Outline key security practices for each phase of the AI lifecycle.",
    "description": "Security starts with planning and continues through data handling, model development, deployment, and maintenance. Key practices include performing risk assessments, minimizing data collection, verifying data sources, securing model infrastructure, and monitoring for data drift or attacks."
  },
  {
    "id": 113,
    "topic_id": 200,
    "title": "Understand human-centric AI design principles.",
    "description": "Human-centric design keeps people in control of AI decisions. It includes human-in-the-loop processes for critical actions, oversight systems for monitoring behavior, and regular validation to catch bias or errors. Transparency and user empowerment help build trust and support ethical use of AI."
  },
  {
    "id": 114,
    "topic_id": 200,
    "title": "Understand the wide variety of attacks that target AI systems.",
    "description": "AI systems are vulnerable to many types of threats, including prompt injection, model and data poisoning, model inversion, jailbreaks, and manipulation of application integrations. These attacks often exploit the flexibility and unpredictability of AI, using subtle inputs or environmental tricks rather than traditional exploits."
  },
  {
    "id": 115,
    "topic_id": 200,
    "title": "Know how prompt injection works and why it’s especially dangerous.",
    "description": "Prompt injection manipulates a model by incorporating malicious instructions into inputs, often without requiring privileged access. These attacks can directly override system behavior or act through hidden content in documents and web pages, making them difficult to detect and prevent."
  },
  {
    "id": 116,
    "topic_id": 200,
    "title": "Be able to identify and explain common compensating controls used in AI security.",
    "description": "Controls like prompt firewalls, model guardrails, and access restrictions help mitigate the impact of attacks. These tools work at different stages—some filtering inputs, others shaping outputs or enforcing runtime policies—to reduce the risk of misuse or harm."
  },
  {
    "id": 117,
    "topic_id": 200,
    "title": "Apply the principle of least privilege to model access.",
    "description": "Users and components should only be granted the permissions necessary to perform their specific function. Granular access controls, role-based policies, and contextual restrictions help prevent abuse and reduce the blast radius of a compromise."
  },
  {
    "id": 118,
    "topic_id": 200,
    "title": "Recognize the role of rate limiting and encryption in AI defense.",
    "description": "Rate limiting slows down attacks such as model theft or denial of service, giving defenders more time to respond. Encryption ensures the confidentiality of data, both in transit and at rest, and is crucial for protecting sensitive model artifacts and user interactions."
  },
  {
    "id": 119,
    "topic_id": 200,
    "title": "Distinguish between data poisoning and model poisoning.",
    "description": "Data poisoning corrupts the training data, steering the model toward wrong or malicious behavior. Model poisoning modifies the model itself (its weights or architecture), often by distributing a doctored pretrained model."
  },
  {
    "id": 120,
    "topic_id": 200,
    "title": "Use threat modeling frameworks to proactively identify AI risks.",
    "description": "Structured models like MITRE ATLAS and the OWASP Top Ten provide guidance for analyzing threats. The MIT AI Risk Repository may be used as a supporting reference for threat modeling. These models help security teams understand adversary techniques and implement controls before incidents occur."
  },
  {
    "id": 121,
    "topic_id": 200,
    "title": "Understand how excessive agency and overreliance increase operational risk.",
    "description": "Excessive agency grants models too much autonomy, leading to unintended actions. Overreliance happens when humans trust model output without verification. Both amplify the impact of AI errors and create new avenues for failure."
  },
  {
    "id": 122,
    "topic_id": 200,
    "title": "Be able to explain the importance of output integrity and secure plug-in design.",
    "description": "AI output should never be blindly trusted or automatically executed. Poorly secured plug-ins and unsanitized outputs can lead to injection attacks, data leaks, or unauthorized actions in connected systems."
  },
  {
    "id": 123,
    "topic_id": 200,
    "title": "Identify how supply chain and transfer learning attacks compromise AI systems.",
    "description": "When organizations use pretrained models or external datasets, they inherit upstream risks. Attacks may be hidden in public models or poisoned training data, persisting even after fine-tuning and deployment."
  },
  {
    "id": 124,
    "topic_id": 200,
    "title": "Understand the role of model-level security controls.",
    "description": "Model-level controls, including evaluation and guardrails, help ensure that an AI model operates securely and follows established policies. They block harmful behaviors from reaching users by filtering content, restricting outputs, and identifying potential vulnerabilities."
  },
  {
    "id": 125,
    "topic_id": 200,
    "title": "Explain how model evaluation supports AI security.",
    "description": "Model evaluation includes testing for vulnerabilities, bias, and regulatory compliance under both normal and adversarial conditions. It helps identify risks such as prompt injection and data leaks before deployment and guides the selection of appropriate guardrails."
  },
  {
    "id": 126,
    "topic_id": 200,
    "title": "Describe how prompt templates reduce injection risks.",
    "description": "Prompt templates use fixed structures with defined input slots. This design prevents user content from overriding system instructions and, similar to parameterized queries, helps protect against prompt injection attacks."
  },
  {
    "id": 127,
    "topic_id": 200,
    "title": "Recognize the function of prompt firewalls.",
    "description": "Prompt firewalls inspect and filter both incoming and outgoing content to block malicious inputs, sanitize sensitive outputs, and prevent unauthorized instructions from reaching the model."
  },
  {
    "id": 128,
    "topic_id": 200,
    "title": "Recognize important access control practices for AI systems.",
    "description": "Controlling access to models, data, agents, and APIs requires authentication and authorization, protection of artifacts, and enforcement of usage limits. These measures help prevent misuse and reduce the risk of resource abuse."
  },
  {
    "id": 129,
    "topic_id": 200,
    "title": "Understand the application of encryption in AI systems.",
    "description": "Encryption at rest, in transit, and in use safeguards training data, model artifacts, and operational data from unauthorized access. These protections can include methods such as confidential computing and homomorphic encryption."
  },
  {
    "id": 130,
    "topic_id": 200,
    "title": "Explain data safety and privacy techniques.",
    "description": "Techniques such as anonymization, classification, redaction, masking, and minimization help protect personal and sensitive data across the AI life cycle while supporting compliance and reducing exposure to risks."
  },
  {
    "id": 131,
    "topic_id": 200,
    "title": "Understand the purpose of prompt and response monitoring.",
    "description": "Monitoring prompts and responses allows administrators to detect malicious inputs, sensitive data leaks, and unsafe outputs. It supports compliance by ensuring queries and responses are logged, reviewed, and filtered for policy violations such as disallowed topics or exposure of personal information."
  },
  {
    "id": 132,
    "topic_id": 200,
    "title": "Explain how log monitoring, sanitization, and protection safeguard AI systems.",
    "description": "Log monitoring provides visibility into system activity, enabling quick detection of anomalies such as failed login attempts or unusual API use. Sanitization removes sensitive data such as credit card numbers from logs. Protection measures including encryption, access controls, and retention policies ensure logs remain trustworthy and resistant to tampering."
  },
  {
    "id": 133,
    "topic_id": 200,
    "title": "Recognize the role of confidence monitoring in decision-making.",
    "description": "Tracking model confidence values helps determine when outputs can be trusted and when they require human review. For generative AI, secondary models or probability analysis may be needed. Confidence thresholds improve safety by preventing low-certainty outputs from being acted on automatically."
  },
  {
    "id": 134,
    "topic_id": 200,
    "title": "Differentiate between rate monitoring, rate limiting, and throttling.",
    "description": "Rate monitoring detects abnormal usage patterns that may indicate denial-of-service attacks or malfunctioning clients. Rate limiting rejects requests that exceed defined thresholds. Throttling slows the rate of request processing to preserve availability. These practices protect system stability and ensure fair use across users."
  },
  {
    "id": 135,
    "topic_id": 200,
    "title": "Understand the importance of monitoring AI costs.",
    "description": "Cost monitoring tracks token usage, compute resources, storage growth, and third-party API calls. Practices such as budget alerts, per-request limits, and utilization reviews prevent unexpected expenses and promote accountability across teams and departments."
  },
  {
    "id": 136,
    "topic_id": 200,
    "title": "Explain the objectives of AI auditing for quality and compliance.",
    "description": "Auditing evaluates outputs and processes to ensure systems remain accurate, fair, and legally compliant. This includes detecting hallucinations, verifying accuracy, checking for bias, and reviewing access controls. Regular audits confirm that safeguards are functioning as intended and that organizational standards and regulations are consistently met."
  },
  {
    "id": 137,
    "topic_id": 200,
    "title": "Understand how AI-generated content enables deepfake and impersonation attacks.",
    "description": "Generative AI tools can create realistic text, images, audio, and video that mimic real people, enabling deepfakes and other impersonation attacks. These synthetic assets are used in phishing, fraud, and social engineering, where attackers pose as trusted individuals to deceive targets. The realism of AI-generated content makes traditional verification methods less effective."
  },
  {
    "id": 138,
    "topic_id": 200,
    "title": "Know how AI facilitates misinformation and disinformation campaigns.",
    "description": "Misinformation involves unintentionally spreading false content, while disinformation is a deliberate attempt to manipulate opinions. AI can create persuasive synthetic media, tailor narratives in multiple languages, and automate distribution across platforms. These campaigns can influence public events, erode trust, and bypass traditional media verification processes."
  },
  {
    "id": 139,
    "topic_id": 200,
    "title": "Recognize how adversarial networks can defeat detection systems.",
    "description": "Generative adversarial networks (GANs) can produce content that appears authentic to both humans and machines. Attackers may indirectly use GANs to evade AI detectors, poison models, or trick decision systems. Adversarial patches and subtle modifications can mislead AI in applications like autonomous driving and content moderation."
  },
  {
    "id": 140,
    "topic_id": 200,
    "title": "Explain how AI enhances reconnaissance and data collection.",
    "description": "AI models can automate the collection and analysis of open source and leaked data to identify targets and vulnerabilities. Threat actors use large language models to synthesize reconnaissance findings, prioritize attack surfaces, and prepare customized phishing or intrusion strategies at scale."
  },
  {
    "id": 141,
    "topic_id": 200,
    "title": "Understand how AI increases the scale and effectiveness of social engineering.",
    "description": "Modern language models may generate believable phishing emails, clone voices for vishing attacks, and simulate human conversation in fake chatbot interfaces. These tactics deceive victims into providing credentials or making payments by imitating trusted contacts or organizations."
  },
  {
    "id": 142,
    "topic_id": 200,
    "title": "Identify how generative AI supports code obfuscation and polymorphic malware.",
    "description": "AI can rewrite malicious code to create endless unique variants that evade detection. Malware may query language models at runtime to generate payloads on the fly. Attackers also use AI to encode commands in images or social media posts, hiding malicious behavior from traditional monitoring tools."
  },
  {
    "id": 143,
    "topic_id": 200,
    "title": "Know how AI enables automated data correlation for faster intrusion.",
    "description": "Attackers use AI to correlate stolen credentials, personal details, and internal system data, creating prioritized lists of exploitable targets. This reduces the time from data acquisition to compromise, as AI agents sift through massive datasets and identify the most valuable or vulnerable accounts."
  },
  {
    "id": 144,
    "topic_id": 200,
    "title": "Understand the role of AI in automated attack generation.",
    "description": "AI agents automate every stage of an intrusion, from vulnerability scanning to exploit selection and execution. These tools enable unskilled attackers to launch multistep campaigns, generating payloads and adapting to defenses in real time without writing code manually."
  },
  {
    "id": 145,
    "topic_id": 200,
    "title": "Describe how attackers use AI to detect and evade honeypots.",
    "description": "Machine learning models analyze service responses and behavior patterns to identify and avoid honeypots. Attackers also build malicious honeypots that mimic legitimate interfaces to steal credentials or distribute malware, and they may analyze compromised honeypot data to refine their tactics."
  },
  {
    "id": 146,
    "topic_id": 200,
    "title": "Recognize how AI-powered DDoS attacks adapt in real time.",
    "description": "AI-driven botnets analyze live traffic conditions to fine-tune their attack vectors dynamically. They adjust port targets, packet types, and timing based on real-time feedback, making them harder to block. This sophistication requires defenders to move beyond static block lists and embrace AI-based mitigation tools."
  },
  {
    "id": 147,
    "topic_id": 200,
    "title": "Know the types of AI-enabled security tools and where they are used.",
    "description": "AI tools can be integrated into IDEs, browsers, command-line interfaces, and chat interfaces. These plug-ins provide contextual security insights, autocomplete suggestions, code scanning, log summarization, and more. This allows security professionals and developers to detect and remediate threats within their existing workflows."
  },
  {
    "id": 148,
    "topic_id": 200,
    "title": "Understand how AI assistants and chatbots enhance cybersecurity operations.",
    "description": "AI chatbots help analysts query security data using natural language, automate investigations, and enrich incident details. Personal assistants support task management, generate summaries, and coordinate communications across platforms like email and Slack, reducing the burden of manual reporting."
  },
  {
    "id": 149,
    "topic_id": 200,
    "title": "Be able to apply AI to common security use cases.",
    "description": "AI assists with tasks such as signature matching, anomaly detection, vulnerability analysis, threat modeling, and fraud detection. It increases accuracy, improves response times, and reduces the manual effort needed to triage and remediate security issues."
  },
  {
    "id": 150,
    "topic_id": 200,
    "title": "Use AI to improve code security and quality.",
    "description": "AI plug-ins can detect insecure coding practices, highlight vulnerable libraries, and recommend secure patterns. These tools provide real-time feedback during development, helping teams shift security left in the software life cycle and enforce secure coding standards without slowing delivery."
  },
  {
    "id": 151,
    "topic_id": 200,
    "title": "Know how AI enables automation across incident response and change management.",
    "description": "AI automates ticket creation, incident correlation, containment recommendations, and post-incident summaries. In change management, it can assess proposed changes, recommend rollbacks, auto-approve routine updates, and monitor for unexpected behavior during deployments."
  },
  {
    "id": 152,
    "topic_id": 200,
    "title": "Recognize the role of AI in CI/CD pipelines.",
    "description": "AI enhances CI/CD workflows by performing intelligent code scanning, dependency analysis, test case generation, and regression testing. It supports model testing, deployment monitoring, and automated rollback to ensure fast and secure software releases."
  },
  {
    "id": 153,
    "topic_id": 200,
    "title": "Differentiate between low-code, no-code, and scripting tools in AI-powered automation.",
    "description": "AI lowers the barrier to automation by generating scripts from natural language, enabling broader team participation. It supports scripting in traditional environments and complements low-code/no-code platforms by building logic, summarizing results, and managing execution steps."
  },
  {
    "id": 154,
    "topic_id": 200,
    "title": "Understand how AI supports document synthesis and summarization.",
    "description": "Security professionals can use AI to condense lengthy reports, advisories, logs, and meeting notes. This allows teams to quickly identify critical information, streamline communication, and ensure consistent messaging across stakeholders."
  },
  {
    "id": 155,
    "topic_id": 200,
    "title": "Know how AI agents differ from other automation tools.",
    "description": "AI agents operate with autonomy to monitor environments, investigate suspicious behavior, and execute response actions. Unlike simple automation scripts, agents can plan, adapt, and act independently within defined guardrails—helping teams scale their security efforts in dynamic environments."
  },
  {
    "id": 156,
    "topic_id": 200,
    "title": "Use AI for translation and summarization in global threat analysis.",
    "description": "AI translation tools convert foreign-language threat data, phishing messages, or attacker communications into actionable intelligence. Summarization tools extract key findings from large documents or logs, helping teams focus on the most important risks quickly."
  },
  {
    "id": 157,
    "topic_id": 200,
    "title": "Understand the different organizational structures used to manage AI initiatives.",
    "description": "Organizations structure AI governance using centralized, federated, or embedded models. A centralized Center of Excellence (CoE) sets standards, manages platforms, and supports project teams. As programs mature, many shift to a hub-and-spoke model where the CoE (hub) provides shared resources and oversight, while business units (spokes) drive execution. Some organizations fully embed AI roles in product teams with a light central layer to maintain coherence. Regardless of structure, clear handoffs, short intake forms, and automation reduce bureaucracy and enable safe, fast delivery."
  },
  {
    "id": 158,
    "topic_id": 200,
    "title": "Recognize the key AI-related roles and their responsibilities across the life cycle.",
    "description": "AI programs succeed when responsibilities are clearly assigned across specialized roles. Product leaders frame use cases; data scientists and engineers prepare data and train models; ML engineers and platform teams deploy and manage infrastructure; and risk, security, and legal professionals ensure compliance. Roles such as AI security architect, risk analyst, and auditor provide critical oversight and separation of duties. Even in small teams, life cycle coverage and accountability are essential."
  },
  {
    "id": 159,
    "topic_id": 200,
    "title": "Apply responsible AI principles to design and operate safe, fair, and transparent systems.",
    "description": "Responsible AI turns ethical principles into daily practice through structured choices and documented evidence. Key principles include fairness, reliability and safety, transparency, privacy and security, explainability, inclusiveness, accountability, and consistency. These principles guide every phase from problem selection to monitoring. Teams should define success metrics, track bias across subgroups, and maintain clear documentation such as model cards, evaluation reports, and audit trails."
  },
  {
    "id": 160,
    "topic_id": 200,
    "title": "Identify and mitigate the key risks associated with AI systems.",
    "description": "AI introduces risks such as bias, data leakage, reputational harm, underperformance, IP violations, and misbehavior in autonomous systems. Risk increases with high impact, wide exposure, or uncertainty. Mitigations include red teaming, drift monitoring, governance reviews, and incident response planning. CompTIA categorizes risks to guide teams in applying proactive and reactive controls that ensure safety and reliability over time."
  },
  {
    "id": 161,
    "topic_id": 200,
    "title": "Understand the implications of the EU AI Act and other laws regulating AI.",
    "description": "The EU AI Act classifies AI systems by risk and imposes strict obligations on high-risk use cases, including documentation, transparency, and human oversight. Organizations must conduct impact assessments, track approvals, and ensure systems align with declared purpose. Compliance requirements influence design decisions, vendor selection, and deployment timelines. Even non-EU companies must prepare if their systems touch the EU market."
  },
  {
    "id": 162,
    "topic_id": 200,
    "title": "Familiarize yourself with international AI standards frameworks.",
    "description": "Global bodies provide frameworks that support trustworthy AI. The OECD promotes principles such as transparency, robustness, and accountability. ISO publishes standards on risk, safety, and system life cycles. NIST’s AI Risk Management Framework (AIRMF) offers practical guidance to identify, assess, and manage AI risks. These frameworks help organizations align policy, technical design, and auditing practices to industry best practices."
  },
  {
    "id": 163,
    "topic_id": 200,
    "title": "Implement effective corporate AI policies and procedures.",
    "description": "Corporate AI policies translate principles into enforceable rules. Policies define who can use AI, for what tasks, under what conditions, and with what safeguards. Standards define the minimum bar for controls, procedures explain how to meet them, and guidelines offer flexibility. Well-written policies support safety, prevent shadow AI, and produce audit-ready evidence. Key questions address use case approval, data handling, vendor risk, access controls, and prompt review."
  },
  {
    "id": 164,
    "topic_id": 200,
    "title": "Use third-party evaluations to validate AI compliance.",
    "description": "External assessments and audits help verify that AI systems meet internal standards and regulatory requirements. Auditors sample systems, trace decisions, and evaluate control effectiveness. Vendor assessments check for data use restrictions, residency guarantees, and performance safeguards. Independent assurance provides credibility with customers, regulators, and partners, and supports a robust governance program."
  }
];
